module.exports = __webpack_public_path__ + "static/media/drizzle.811110bd.svg";